import React, { FunctionComponent } from 'react';
import { Card } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../helpers/html.utils';
import { ILabel } from '../../../models/common/label.model';
import { IPDPPriceBreakItem } from '../../../models/pdp/pdp-price-break-item.model';
import styles from './price-break-table-component.module.scss';

type PriceBreakTableProps = {
  labels?: ILabel[] | null;
  prices: IPDPPriceBreakItem[];
  selectedQty?: number;
  packPriceHeader?: string | null;
};

export const PriceBreakTable: FunctionComponent<PriceBreakTableProps> = (props: PriceBreakTableProps) => {
  const hasDiscount = props.prices.some((p) => p.unitPrice.priceBefore?.value !== p.unitPrice.priceAfter?.value);
  const hasPackPrice = props.prices.some((p) => p.unitPrice.priceBefore?.value !== p.packPrice.priceBefore?.value);

  return (
    <Card className={styles['price-break-container']} squareCorners={true}>
      <div className={styles.breakdown}>
        <table data-testid='price-break-table'>
          <thead>
            <tr>
              <th className={!hasDiscount && !hasPackPrice ? styles.wide : ''}>{getLabel(props.labels, 'quantity')}</th>
              <th align={!hasDiscount && !hasPackPrice ? 'right' : undefined}>{getLabel(props.labels, 'unit_price')}</th>
              {hasDiscount && <th>{getLabel(props.labels, 'your_unit_price')}</th>}
              {hasPackPrice && <th>{props.packPriceHeader}</th>}
            </tr>
          </thead>
          <tbody>
            {props.prices.map((p) => {
              return (
                <tr
                  className={props.selectedQty && props.selectedQty >= p.minimum && props.selectedQty <= p.maximum ? 'active' : ''}
                  key={p.displayName}>
                  <td>{p.displayName}</td>
                  <td>{p.unitPrice.priceBefore?.displayValue}</td>
                  {hasDiscount && <td>{p.unitPrice.priceAfter?.displayValue}</td>}
                  {hasPackPrice && <td>{p.packPrice.priceBefore?.displayValue}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

export default PriceBreakTable;
